
import { useState, useEffect } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import EmotionRegistrationForm from '@/components/forms/EmotionRegistrationForm';
import WorkPerformanceForm from '@/components/forms/WorkPerformanceForm';
import { CircleDecor } from '@/components/ui/visual-elements';
import { useLocation } from 'react-router-dom';

const Registration = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    // Check if we're coming from the emotions dashboard
    if (location.state && location.state.defaultTab === 'work') {
      return 'work';
    }
    return 'emotions'; // Default tab is 'emotions'
  });
  
  useEffect(() => {
    // Update tab if state changes (for instance, if user navigates here multiple times)
    if (location.state && location.state.defaultTab) {
      setActiveTab(location.state.defaultTab);
    }
  }, [location.state]);
  
  return (
    <MainLayout>
      <div className="container mx-auto p-6 relative">
        <CircleDecor className="absolute top-10 right-10 opacity-10" variant="secondary" size="lg" />
        <CircleDecor className="absolute bottom-20 left-10 opacity-10" size="sm" />
        
        <h1 className="text-2xl font-bold mb-8">painel de registro</h1>
        <p className="text-gray-600 mb-8">
          acompanhe seu bem-estar emocional e desempenho profissional diariamente
        </p>
        
        <Tabs
          defaultValue={activeTab}
          value={activeTab}
          onValueChange={setActiveTab}
          className="w-full max-w-4xl mx-auto"
        >
          <TabsList className="grid w-full grid-cols-2 mb-8">
            <TabsTrigger value="emotions">Emoções</TabsTrigger>
            <TabsTrigger value="work">Desempenho no Trabalho</TabsTrigger>
          </TabsList>
          
          <TabsContent value="emotions">
            <EmotionRegistrationForm />
          </TabsContent>
          
          <TabsContent value="work">
            <WorkPerformanceForm />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
};

export default Registration;
